import { useEffect, useState } from "react";
import useApi from "../../../../../hooks/use-api";
import { useForm } from "react-hook-form";
import styles from '../../../../../styles/transitionplan.module.css';
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { EmptyStringToNull, PrepareNullableDataForSend } from "../../../../../utilities/rhfdatanormalizationfunctions";

const ServicesAddEdit = ({ApplicationID,NeedID,GoalID,ServiceID,ReturnFunction,RefreshFunction}) => {
    const [isLoading,SetisLoading] = useState(true);
    const [serviceTypes,setServiceTypes] =  useState([]);
    const [feedback, setFeedback] = useState(null);

    const initialValues = {
        ServiceTypeID: '',
        Comments: ''
    }

    const {control,register,handleSubmit,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    const {getRequest,postRequest,putRequest} = useApi();

    const _onSubmit = async(items) => {
        setFeedback(null);
        const submitData = PrepareNullableDataForSend(items);

        if(ServiceID){
            const [data,status] = await putRequest('UpdateService',{...submitData,ApplicationID : ApplicationID,NeedID: NeedID,GoalID: GoalID,ServiceID: ServiceID});

            if(status === 200){
                setFeedback({ type: "success", message: "The Service was successfully updated." });
                
                const extractedData = {
                    ServiceTypeID: data.servicetypeid,
                    Comments: data.comments
                }

                reset(extractedData);
                RefreshFunction({ preserveEditorViewport: true });
                
            }
            else{
                setFeedback({ type: "error", message: "An error occurred when updating the Service." });
            }
        }
        else{
            const [data,status] = await postRequest('AddService',{...submitData,ApplicationID: ApplicationID,NeedID: NeedID,GoalID: GoalID});

            if(status === 201){
                setFeedback({ type: "success", message: "The Service was successfully added." });
        
                RefreshFunction({ preserveEditorViewport: true });
                reset(initialValues);
            }
            else{
                setFeedback({ type: "error", message: "An error occurred when adding the Service." });
            }
        }
    }

    const getTypes = async () => {
        SetisLoading(true);
        const [data,status] = await getRequest('ServiceTypes',{timestamp: Date.now()});
        SetisLoading(false);

        if(status === 200){
            setServiceTypes(data);
        }
        else{
            //Handle error
            setServiceTypes([]);
        }
    }

    const get =  async() => {
        SetisLoading(true);
        const [typesData,serviceData] = await Promise.all([
            getRequest('ServiceTypes'),
            getRequest('Service',{ApplicationID : ApplicationID,NeedID : NeedID,GoalID: GoalID,ServiceID: ServiceID})
        ]);

        SetisLoading(false);

        const [extractedTypeData,typeStatus] = typesData;
        const [extractedServiceData,serviceStatus] = serviceData;

        if(typeStatus === 200 && serviceStatus === 200){
            setServiceTypes(extractedTypeData);

            const{id,...dataValues} = extractedServiceData;


            reset({
                Comments: dataValues.comments === null ? '' : dataValues.comments,
                ServiceTypeID: dataValues.servicetypeid === null ? '' : dataValues.servicetypeid
            });
        }
        else{
            setServiceTypes([]);
        }
    }

    useEffect(() => {
        if(ServiceID){
            get();
        }
        else{
            getTypes();
        }
    },[ServiceID])

    if(isLoading){
        return(
            <div className={styles.statusMessage} role="status" aria-live="polite">Loading service form...</div>
        )
    }

    return(
        <form onSubmit={handleSubmit(_onSubmit)}>
            <div className={`clientCard ${styles.editorEmbeddedCard}`}>
                <div className={`${styles.needBody} ${styles.editorEmbeddedBody}`}>
                    <label htmlFor="ServiceType">Service Type</label>
                    <select id="ServiceType" style={{width: '100%'}} {...register("ServiceTypeID")}>
                        <option value=''>--Select Type--</option>
                        {
                            serviceTypes.map((type) => (
                                <option key={type.id} value={type.id}>{type.name}</option>
                            ))
                        }
                    </select>
                    <label htmlFor="Comments">Comments</label>
                    <textarea rows={5} id="Comments" {...register("Comments")} style={{width: '100%'}}/>
                    {feedback && (
                        <div className={`${styles.inlineFeedback} ${feedback.type === "error" ? styles.inlineFeedbackError : styles.inlineFeedbackSuccess}`} role="status" aria-live="polite">
                            {feedback.message}
                        </div>
                    )}
                    <div className="d-flex justify-content-end">
                        <Button type="submit" variant={ServiceID !== null ? 'primary' : 'success'} disabled={isLoading || !isDirty || isSubmitting}>
                            {
                                isSubmitting
                                ?
                                    <Spinner animation='border' size='sm' aria-hidden="true" />
                                :
                                    ServiceID
                                    ?
                                        <>
                                            <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                            Save
                                        </>
                                    :
                                        <>
                                            <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                            Add Service
                                        </>
                            }
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ServicesAddEdit;
